import { render, staticRenderFns } from "./RoomDeletionNotice.vue?vue&type=template&id=23b27b9b&"
import script from "./RoomDeletionNotice.vue?vue&type=script&lang=js&"
export * from "./RoomDeletionNotice.vue?vue&type=script&lang=js&"
import style0 from "./RoomDeletionNotice.vue?vue&type=style&index=0&id=23b27b9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports